<template>
  <div>
    <div class="toolbar">
      <el-form :inline="true" :model="q" size="mini" label-width="80px">
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="q.time_range"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            :picker-options="pickerOptions"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="用户ID:">
          <el-input v-model="q.user_id" placeholder="请输入用户ID" prefix-icon="el-icon-edit"></el-input>
        </el-form-item>

        <el-form-item label="关联代理:">
          <el-select v-model="q.agency_id" clearable filterable placeholder="请输入代理账号">
            <el-option
              v-for="item of AgencyList"
              :key="item.id"
              :label="item.id+'>'+item.user_name+'>'+item.nickname"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="120" label="所属商户:">
          <el-select v-model="q.mch_id" clearable placeholder="请选择">
            <el-option
              v-for="item in MerchantsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="评价类型:">
          <el-select v-model="q.comment_star" clearable placeholder="请选择">
            <el-option
              v-for="(value, key) of $store.state.app.evaluationType"
              :key="key"
              :label="value"
              :value="key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单ID:">
          <el-input v-model="q.order_id" placeholder="订单ID" prefix-icon="el-icon-edit"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button type="danger" @click="reload">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="listData.items"
      v-loading.body="listLoading"
      @sort-change="sortlist"
      size="mini"
      stripe
      border
      fit
      highlight-current-row
    >
      <el-table-column prop="id" label="评价ID" width="80"></el-table-column>
      <el-table-column prop="user_id" label="用户ID" min-width="120"></el-table-column>
      <el-table-column prop="mch_name" label="所属商户" min-width="180">
        <template slot-scope="scope">{{scope.row.mch.name}}</template>
      </el-table-column>
      <el-table-column prop="agency_nickname" label="关联代理" width="100">
        <template slot-scope="scope">{{scope.row.agency.user_name}}</template>
      </el-table-column>
      <el-table-column prop="order_id" label="订单ID" width="120"></el-table-column>
      <el-table-column prop="amount" label="支付金额" width="100"></el-table-column>
      <el-table-column prop="comment_star" label="评价类型" width="100">
        <template slot-scope="scope">
          <div>{{$store.state.app.evaluationType[scope.row.comment_star] || scope.row.comment_star}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="评价时间" width="200"></el-table-column>
      <el-table-column prop="success_at" label="订单完成时间" width="200"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="q.page_no"
        :page-sizes="$store.state.app.pageSizeArr"
        :page-size="q.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listData.total"
      ></el-pagination>
    </div>
    <detailed v-if="showDetails" :showDetails.sync="showDetails" :rowInfo="rowInfo"></detailed>
  </div>
</template>

<script>
import timedate from "@/utils/timedate.js";
import { getOrderEvaluation,  getAgencyList } from "@/api";
import { queryFilter } from "@/utils/patch";
import {
  FormartCommentStar,
  FormartCommentRank,
} from "../../utils/CommonJs";
import detailed from "./detailed";
import downloadExcel from "@/utils/downloadExcel";
export default {
  components: { detailed },
  data() {
    return {
      listData: {},
      q: { page_size: 30, page_no: 1, agency_type: 2 },
      listLoading: false,
      showUpdate: false,
      settleCycle: this.$store.state.app.settleCycle,
      show_id: null,
      MerchantsList: this.$store.state.user.userinfo.mchs,
      AgencyType: this.$store.state.app.AgencyType,
      PayMethodType: this.$store.state.app.payType,
      RecepiptMethodType: {
        1: "支付宝",
        2: "微信",
        3: "银行卡"
      },
      isEnable: false,
      isShow: false,
      showDetails: false,
      searchTime: [],
      score: 0,
      starOptions: [
        { value: 1, label: "1星" },
        { value: 2, label: "2星" },
        { value: 3, label: "3星" },
        { value: 4, label: "4星" },
        { value: 5, label: "5星" }
      ],
      rankOptions: [
        { value: 1, label: "差评" },
        { value: 2, label: "中评" },
        { value: 3, label: "好评" }
      ],
      comment_star_arrty: [],
      AgencyMainList: [],
      AgencyList: [],
      downloading: false,
     pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateTodayHMS,
                timedate.dateTodayHMS
              ]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateYesterdayHMS,
                timedate.dateYesterdayHMS
              ]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateWeekHMS,
                timedate.dateTodayHMS
              ]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateOneMonthHMS,
                timedate.dateTodayHMS
              ]);
            }
          }
        ]
      }
    };
  },
  activated() {
    this.getList();
    this.getAgencyList();
    this.getChildAgencyList();
  },
  deactivated() {
    this.listLoading = false;
  },
  methods: {
    downloadData() {
      // queryFilter(this.q)
      queryFilter(this.q);
      this.downloading = true;
      getOrderEvaluation(Object.assign({}, this.q, { export: 1 }))
        .then(res => {
          if (res.status === 0) {
            downloadExcel(this, res.data.task_id);
          }
        })
        .catch(error => {
          this.downloading = false;
        });
    },
    query() {
      this.q = Object.assign(this.q, { page_no: 1, page_size: 30 });
      this.getList();
    },
    reload() {
      this.q = { page_size: 30, page_no: 1 };
      this.getList();
    },
    showDetailed(row) {
      this.showDetails = true;
      this.rowInfo = row;
    },
    sortlist(sort) {
      this.q.$orderby = sort.prop;
      this.getList();
    },
    handleSizeChange(val) {
      this.q.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.q.page_no = val;
      this.getList();
    },
    getList() {
      const query = this.$dateFilter({
        data: this.q,
        range: "time_range",
        start: "created_at_begin",
        end: "created_at_end"
      });
      getOrderEvaluation(queryFilter(query)).then(res => {
        if (res.status === 0) {
          this.listLoading = false;
          this.listData = res.data;
          this.listData.items = Array.from(res.data.items, x =>
            Object.assign({}, x, { amount: Number(x.amount) / 100 })
          );
        }
      });
    },
    getAgencyList() {
      getAgencyList({ agency_type: 2, page_size: 1000 }).then(res => {
        if (res.status === 0) {
          this.AgencyMainList = res.data.items;
        }
      });
    },
    getChildAgencyList() {
      getAgencyList({ agency_type: 1, page_size: 1000 }).then(res => {
        if (res.status === 0) {
          this.AgencyList = res.data.items;
        }
      });
    },
    typeFormartter(row, column) {
      let columnName = column.property;
      if (columnName === "enable") {
        return row.enable ? "是" : "否";
      } else if (columnName === "working") {
        return row.working ? "是" : "否";
      }
    },
    exportExcel() {
      this.$message({ message: "待开发", type: "error" });
    },
    FormartComment(row, column) {
      if (column.property == "comment_star") {
        return FormartCommentStar(row.comment_star);
      } else if (column.property == "comment_rank") {
        return FormartCommentRank(row.comment_rank);
      }
    }
  },
  watch: {
    showUpdate() {
      if (!this.showUpdate) {
        this.getList();
      }
    }
  }
};
</script>

<style type="text/css">
.el-form-item__label {
  width: 100px !important;
}
</style>
